import { render, staticRenderFns } from "./BoardItem.vue?vue&type=template&id=61474a62&scoped=true&"
import script from "./BoardItem.vue?vue&type=script&lang=js&"
export * from "./BoardItem.vue?vue&type=script&lang=js&"
import style0 from "./BoardItem.vue?vue&type=style&index=0&id=61474a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61474a62",
  null
  
)

export default component.exports